<div class="ops-language-select-container">
  <select
    class="ops-language-select"
    [ngModel]="value"
    (ngModelChange)="onLanguageChange($event)"
    aria-label="Select language"
  >
    <option
      *ngFor="let option of languageOptions"
      [value]="option.code"
      class="language-option"
    >
      <!-- {{ option.flag }} -->
      {{ option.nativeName }} ({{ option.name }})
    </option>
  </select>

  <div class="select-arrow">
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L6 6L11 1"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</div>
